import * as React from "react";

import { useLoaderData, useLocation } from "react-router-dom";

import { DataTable } from "../Table";
import { getConfigObject } from "../../fwptools";

import PageLayout from "./PageLayout";

export const DataLayout = ({ buttons, columns, selector }) => {
    const config = getConfigObject(useLocation().pathname);
    const data = useLoaderData();

    return (
        <PageLayout buttons={buttons} config={config}>
            <DataTable columns={columns} data={data} selector={selector}/>
        </PageLayout>
    );
};
